(() => {
  const mount = () => {
    const configNode = document.querySelector('[data-iw-booking-config]');
    const dialog = document.getElementById('booking-dialog');
    if (!configNode || !dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const config = JSON.parse(configNode.textContent);
    const scheduler = document.getElementById('iw-scheduler');
    const status = document.getElementById('iw-scheduler-status');
    const retry = document.getElementById('iw-scheduler-retry');
    const widgets = new Map();
    let active;
    let opener;
    let queue = Promise.resolve();

    const showState = entry => {
      if (entry !== active) return;
      status.textContent = entry.error ? config.embedError : entry.ready ? '' : config.loading;
      retry.hidden = !entry.error;
    };

    const initialize = entry => {
      if (entry.ready || entry.loading) return;
      entry.loading = true;
      entry.error = false;
      showState(entry);
      queue = queue.then(() => new Promise(resolve => {
        if (!dialog.isConnected) { entry.loading = false; resolve(); return; }
        widgets.forEach(widget => widget.container.classList.remove('meetings-iframe-container'));
        entry.container.classList.add('meetings-iframe-container');
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
        script.async = true;
        script.dataset.iwMeetingsLoader = 'true';
        const finish = failed => {
          const frame = entry.container.querySelector('iframe');
          if (frame) frame.title = config.frameTitle;
          entry.ready = Boolean(frame) && !failed;
          entry.error = !entry.ready;
          entry.loading = false;
          widgets.forEach(widget => {
            if (widget.ready) widget.container.classList.add('meetings-iframe-container');
          });
          script.remove();
          showState(entry);
          resolve();
        };
        script.addEventListener('load', () => finish(false), {once: true});
        script.addEventListener('error', () => finish(true), {once: true});
        document.head.append(script);
      }));
    };

    retry.addEventListener('click', () => {
      if (!active) return;
      active.container.replaceChildren();
      initialize(active);
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = '';
      opener?.focus();
    });
    document.getElementById('booking-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    document.querySelectorAll('[data-book]').forEach(button => {
      button.addEventListener('click', () => {
        const appointment = config.appointments.find(item => item.kind === button.dataset.book);
        if (!appointment) return;
        opener = button;
        document.getElementById('booking-title').textContent = appointment.title;
        document.getElementById('appointment-meta').textContent = appointment.meta;
        const description = document.getElementById('appointment-description');
        description.textContent = appointment.description || '';
        description.hidden = !appointment.description;
        widgets.forEach(widget => { widget.container.hidden = true; });
        active = undefined;
        retry.hidden = true;
        status.textContent = '';
        let url;
        try {
          url = new URL(appointment.url);
          if (url.protocol !== 'https:' || !/^(meetings(?:-[a-z0-9]+)?\.hubspot\.com)$/.test(url.hostname)) url = null;
        } catch { url = null; }
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        if (!url) { status.textContent = config.pending; return; }
        const params = new URLSearchParams(location.search);
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid'].forEach(key => {
          const value = params.get(key);
          if (value) url.searchParams.set(key, value);
        });
        url.searchParams.set('embed', 'true');
        let entry = widgets.get(appointment.kind);
        if (!entry || entry.url !== url.href) {
          entry?.container.remove();
          const container = document.createElement('div');
          container.className = 'iw-meeting-widget';
          container.dataset.src = url.href;
          scheduler.append(container);
          entry = {container, url: url.href, ready: false, loading: false, error: false};
          widgets.set(appointment.kind, entry);
        }
        active = entry;
        entry.container.hidden = false;
        showState(entry);
        initialize(entry);
      });
    });
    document.querySelectorAll('.faq-answer a').forEach(link => {
      if (link.getAttribute('href') === '/pages/other-appointments') link.href = config.otherUrl;
    });
    document.querySelectorAll('a[href="#appointments"]').forEach(link => {
      if (config.pageKind === 'other') link.href = config.firstUrl + '#appointments';
    });
  };
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
